"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioField = void 0;
const react_1 = __importDefault(require("react"));
const RadioField = ({ field, value, onChange, error, disabled, lookups }) => {
    let options = [];
    if (field.options) {
        options = field.options;
    }
    else if (field.lookup && lookups?.[field.lookup]) {
        options = lookups[field.lookup];
    }
    return (react_1.default.createElement("div", { className: "field-group" },
        react_1.default.createElement("label", { className: "field-label" },
            field.label,
            field.required && react_1.default.createElement("span", { className: "required" }, "*")),
        react_1.default.createElement("div", { className: "radio-group" }, options.map((opt) => (react_1.default.createElement("div", { key: opt.value, className: "radio-option" },
            react_1.default.createElement("input", { type: "radio", id: `${field.key}_${opt.value}`, name: field.key, value: String(opt.value), checked: String(value) === String(opt.value), onChange: () => onChange(field.key, opt.value), disabled: disabled }),
            react_1.default.createElement("label", { htmlFor: `${field.key}_${opt.value}` }, opt.label))))),
        error && react_1.default.createElement("div", { className: "field-error" }, error)));
};
exports.RadioField = RadioField;
